
              const Handlebars = require('handlebars');
              const templateFunction = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  return "<span>Type services or keywords</span>\n";
  },"useData":true});
              Handlebars.templates['src/hbs/partials/text_below_search_input.hbs'] = templateFunction;
              export default templateFunction;
              